(() => {
  'use strict';
  if (window.fwLegalUiReady) return;
  window.fwLegalUiReady = true;

  // Reopen the Shopify consent interface without changing any consent choice.
  document.addEventListener('click', async (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('[data-fw-cookie-settings]') : null;
    if (!trigger || trigger.getAttribute('aria-busy') === 'true') return;
    const footer = trigger.closest('[data-fw-legal-footer]');
    const status = footer?.querySelector('[data-fw-cookie-status]');
    trigger.setAttribute('aria-busy', 'true');
    if (status) {
      status.hidden = false;
      status.textContent = (document.documentElement.lang.toLowerCase().startsWith('fr') ? "Ouverture des paramètres des cookies…" : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Apertura delle impostazioni dei cookie…" : globalThis.fwExtraText("fw_extra.s_0f4787076aa253", 'Cookie-Einstellungen werden geöffnet …')));
    }
    try {
      const deadline = Date.now() + 4000;
      while (typeof window.privacyBanner?.showPreferences !== 'function') {
        if (Date.now() >= deadline) throw new Error('Consent interface unavailable');
        await new Promise(resolve => window.setTimeout(resolve, 100));
      }
      await Promise.race([
        Promise.resolve(window.privacyBanner.showPreferences()),
        new Promise((_, reject) => window.setTimeout(() => reject(new Error('Consent interface timed out')), 5000))
      ]);
      if (status) { status.textContent = ''; status.hidden = true; }
    } catch (_) {
      if (status) {
        status.hidden = false;
        status.textContent = (document.documentElement.lang.toLowerCase().startsWith('fr') ? "Les paramètres des cookies sont actuellement indisponibles. Recharge la page ou contacte-nous via la page de contact." : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Le impostazioni dei cookie non sono al momento disponibili. Ricarica la pagina oppure scrivici tramite la pagina dei contatti." : globalThis.fwExtraText("fw_extra.s_2178821d132978", 'Die Cookie-Einstellungen sind derzeit nicht verfügbar. Bitte lade die Seite neu oder wende dich über unsere Kontaktseite an uns.')));
      }
    } finally {
      trigger.removeAttribute('aria-busy');
    }
  });
})();
